import wxSdk from 'weixin-js-sdk' // h5分享用到
import {getSignPackage} from '@/service/adminApis' // 分享接口后台提供，用于获取appid，timestamp，nonceStr，signature
import {wechatMatchMobile} from './common'
import { MEETING_YEAR } from '@/common/index';

const Shares = {
  // h5分享功能
  initRealAuthUrl() {
    // todo 兼容  ios 进入首页后 realAuthUrl 不变化， 在app.vue  缓存首次进入路由 window.entryUrl
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = window.location.href.split('#')[0]
    }
  },
  clearRealAuthUrl() {
    if (typeof window.entryUrl !== 'undefined' || window.entryUrl) {
      window.entryUrl = ''
    }
  },
  shareCode: async function () {
    // todo 只有移动端才注册这个
    // if (!wechatMatchMobile()) {
    //   console.log("不是微信公众号内")
    //   return
    // }
    // 兼容了  ios 进入首页后 realAuthUrl 不变化， 在app.vue  缓存首次进入路由 window.entryUrl
    let signLink = /(Android)/i.test(navigator.userAgent) ? window.location.href : window.entryUrl
    if (encodeURIComponent(signLink) == 'undefined') {
      signLink = window.location.href
    }
    // getSignPackage({url: ''}).then((res) => {
    //   alert(`成功：${JSON.stringify(res)}`);
    // }).catch((error) => {
    //   alert(`失败：${error}`);
    // })
    // return;
    try {
      const res = await getSignPackage({url: signLink})
      wxSdk.config({
        debug: false, // 用来调试
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        // jsApiList: ["updateAppMessageShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        jsApiList: [ 'updateAppMessageShareData'],
      })
      wxSdk.ready(function () {
        wxSdk.checkJsApi({
          jsApiList: ['updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res) {
            // 以键值对的形式返回，可用的api值true，不可用为false
            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
  
            console.log('wxSdk.checkJsApi 以键值对的形式返回，可用的api值true，不可用为false 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}')
            console.log(`wxSdk.checkJsApi updateAppMessageShareData    结果`, res);
          },
        })
  
        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        // TODO 添加时间戳 方式
        const timestamp = new Date().getTime()
        let _origin = window.location.origin
        const link = `${_origin}/invitationLetter${MEETING_YEAR}?a=${timestamp}&t=${new Date().getTime()}`
        wxSdk.updateAppMessageShareData({
          // title: title, // 分享标题
          // desc: desc, // 分享描述
          // link: link+'&t='+ timestamp, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          // imgUrl: imgUrl, // 分享图标
          title: `高毅资产${MEETING_YEAR}投资报告会`,
          imgUrl: `${_origin}/logo-web.jpg`,
          desc: '*本次会议为非公开会议，仅限受邀人员参加。',
          link,
          success: function (res) {
            // alert(`转发成功： ${JSON.stringify(res)}`);
          },
          fail: function (res) {
            // alert(`转发失败： ${JSON.stringify(res)}`);
          },
          // cancel: function () {
          //   console.log('updateAppMessageShareData cancel 用户取消分享后执行的回调函数',`${link}`)
          // },
        })
      })
  
      //  异常失败
      wxSdk.error(function (res) {
        console.log('wxSdk.error 失败', res)
        // alert(`wxSdk.error 失败： ${JSON.stringify(res)}`);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    } catch (error) {
      // console.error('获取签名失败:', error);
      // alert(`接口失败：${JSON.stringify(error)}`);
    }
  },
}
export {Shares}
